import studioLoad from './studio-load';

export default [studioLoad];
